/* ============================================================
   FAV TECHNOLOGY — MOBILE LAYER JS (v5)
   Builds (from existing DOM, no markup edits required):
     1. Header hamburger + slide-in drawer (categories cloned
        from the desktop mega panel, links from the nav bar,
        contact info from the top utility bar).
     2. App-style fixed bottom navigation bar.
     3. Sticky bottom "Add to cart / Request quote" bar on PDP.
   Pure vanilla JS, no dependencies. Safe no-op off mobile pages.

   v5: metinler snippets/stylesheets.liquid icindeki
   window.FAV_MOBILE_I18N koprusunden gelir (Turkce yedeklidir) ve
   uretilen tum ic linkler aktif dilin kok onekiyle yazilir.
   ============================================================ */
(function () {
  'use strict';

  /* ---------------- i18n bridge ---------------- */
  const I18N = window.FAV_MOBILE_I18N || {};
  const T = (k, fallback) => (I18N[k] != null ? I18N[k] : fallback);

  /* Aktif dilin kok oneki: birincil dilde '', /en/ icinde '/en'. */
  var ROOT = String(T('root', '/')).replace(/\/+$/, '');

  /* Uretilen ic linkleri aktif dile tasir. Dis URL'lere dokunmaz. */
  function localeUrl(path) {
    if (!path) return ROOT || '/';
    if (path.charAt(0) !== '/') return path;          // relative / hash / tel: / mailto: / https:
    if (path.charAt(1) === '/') return path;          // //cdn.example.com
    if (!ROOT) return path;                           // birincil dil
    if (path === ROOT || path.indexOf(ROOT + '/') === 0) return path; // zaten onekli
    var out = (ROOT + path).replace(/\/{2,}/g, '/');
    return out.length > 1 ? out.replace(/\/$/, '') : out;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  var ICON_BURGER =
    '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
  var ICON_CLOSE =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>';
  var ICON_CHEV =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 6 15 12 9 18"/></svg>';

  // Bottom-nav icons (24px line icons)
  var SV = 'width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"';
  var ICON_HOME = '<svg ' + SV + '><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V20h14V9.5"/></svg>';
  var ICON_GRID = '<svg ' + SV + '><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>';
  var ICON_FILE = '<svg ' + SV + '><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h6"/></svg>';
  var ICON_USER = '<svg ' + SV + '><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/></svg>';
  var ICON_CART = '<svg ' + SV + '><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.4 12.4a1 1 0 0 0 1 .8h8.7a1 1 0 0 0 1-.8L21 7H6"/></svg>';

  /* ---------------- Header drawer ---------------- */
  function buildDrawer() {
    var headerWrap = document.querySelector('.fav-header .fav-wrap');
    if (!headerWrap || document.getElementById('fav-hamburger')) return;

    var burger = el('button', 'fav-hamburger', ICON_BURGER);
    burger.id = 'fav-hamburger';
    burger.type = 'button';
    burger.setAttribute('aria-label', T('menu', 'Menü'));
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-controls', 'fav-drawer');
    headerWrap.insertBefore(burger, headerWrap.firstChild);

    var backdrop = el('div', 'fav-drawer-backdrop');
    backdrop.id = 'fav-drawer-backdrop';

    var drawer = el('aside', 'fav-drawer');
    drawer.id = 'fav-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', T('menu', 'Menü'));
    drawer.setAttribute('aria-hidden', 'true');
    /* v28 a11y: kapaliyken odaklanilamaz (Lighthouse aria-hidden-focus) */
    drawer.inert = true;
    drawer.setAttribute('inert', '');

    var head = el('div', 'fav-drawer-head', '<b></b>');
    head.firstChild.textContent = T('menu', 'Menü');
    var closeBtn = el('button', 'fav-drawer-close', ICON_CLOSE);
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', T('close', 'Kapat'));
    head.appendChild(closeBtn);
    drawer.appendChild(head);

    var body = el('div', 'fav-drawer-body');

    var extra = document.querySelector('.fav-megamenu .extras a');
    var ctaWrap = el('div', 'fav-drawer-cta');
    var cta = el('a', 'fav-btn fav-btn-primary', extra ? extra.innerHTML : null);
    if (!extra) cta.textContent = T('request_quote', 'Teklif İste');
    cta.href = extra ? extra.getAttribute('href') : localeUrl('/pages/teklif');
    ctaWrap.appendChild(cta);
    body.appendChild(ctaWrap);

    var quick = document.querySelectorAll('.fav-megamenu .main-menu > li > a');
    if (quick.length) {
      var qt = el('div', 'fav-drawer-sec-title');
      qt.textContent = T('quick_access', 'Hızlı Erişim');
      body.appendChild(qt);
      quick.forEach(function (a) {
        var l = el('a', 'fav-drawer-link', a.innerHTML);
        l.href = a.getAttribute('href') || '#';
        body.appendChild(l);
      });
    }

    var dSeq = 0;
    function bindToggle(btn, box, panel) {
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', panel.id);
      btn.addEventListener('click', function () {
        var on = !box.classList.contains('open');
        box.classList.toggle('open', on);
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }

    var roots = document.querySelectorAll('#fav-mega-panel .roots .root-link');
    if (roots.length) {
      var ct = el('div', 'fav-drawer-sec-title');
      ct.textContent = T('all_categories', 'Tüm Kategoriler');
      body.appendChild(ct);

      roots.forEach(function (root) {
        var idx = root.getAttribute('data-root');
        var pane = document.querySelector('#fav-mega-panel .children-pane[data-pane="' + idx + '"]');
        var title = (root.textContent || '').trim();
        var subcats = pane ? pane.querySelectorAll('.subcat .subcat-title') : [];
        var rootHref = root.getAttribute('href') || '#';

        var wrap = el('div', 'fav-dcat');

        if (subcats.length) {
          var tgl = el('button', 'fav-dcat-toggle',
            '<span></span><span class="chev">' + ICON_CHEV + '</span>');
          tgl.type = 'button';
          tgl.firstChild.textContent = title;

          var sub = el('div', 'fav-dcat-sub');
          var all = el('a', 'all');
          all.textContent = T('all', 'Tümü');
          all.href = rootHref;
          sub.appendChild(all);
          subcats.forEach(function (sc) {
            /* v28: 3. seviye (mega paneldeki .subcat ul li a) cekmecede ic ice acilir grup olarak */
            var leaves = sc.parentElement ? sc.parentElement.querySelectorAll('ul li a') : [];
            if (leaves.length) {
              dSeq += 1;
              var g = el('div', 'fav-dcat fav-dcat2');
              var t2 = el('button', 'fav-dcat-toggle fav-dcat2-toggle',
                '<span></span><span class="chev">' + ICON_CHEV + '</span>');
              t2.type = 'button';
              t2.firstChild.textContent = sc.textContent.trim();
              var s2 = el('div', 'fav-dcat-sub fav-dcat2-sub');
              s2.id = 'fav-dcat-sub-' + dSeq;
              var all2 = el('a', 'all');
              all2.textContent = T('all', 'Tümü');
              all2.href = sc.getAttribute('href') || '#';
              s2.appendChild(all2);
              leaves.forEach(function (lf) {
                var la = el('a', null, null);
                la.textContent = lf.textContent.trim();
                la.href = lf.getAttribute('href') || '#';
                s2.appendChild(la);
              });
              bindToggle(t2, g, s2);
              g.appendChild(t2);
              g.appendChild(s2);
              sub.appendChild(g);
            } else {
              var a = el('a', null, null);
              a.textContent = sc.textContent.trim();
              a.href = sc.getAttribute('href') || '#';
              sub.appendChild(a);
            }
          });

          dSeq += 1;
          sub.id = 'fav-dcat-sub-' + dSeq;
          bindToggle(tgl, wrap, sub);
          wrap.appendChild(tgl);
          wrap.appendChild(sub);
        } else if (pane && pane.querySelector('.fav-mega-proj')) {
          /* v27: tum alt ogeleri bos olan kok dal -> proje bazli tedarik */
          var proj = pane.querySelector('.fav-mega-proj');
          var ptgl = el('button', 'fav-dcat-toggle',
            '<span></span><span class="chev">' + ICON_CHEV + '</span>');
          ptgl.type = 'button';
          ptgl.firstChild.textContent = title;
          var psub = el('div', 'fav-dcat-sub');
          var pall = el('a', 'all');
          pall.textContent = T('all', 'Tümü');
          pall.href = rootHref;
          psub.appendChild(pall);
          var pa = el('a', 'fav-dcat-proj');
          var ptag = proj.querySelector('.fav-mega-proj-tag');
          var pcta = proj.querySelector('.fav-mega-proj-cta');
          pa.textContent = ((ptag ? ptag.textContent.trim() : '') + ' — ' + (pcta ? pcta.textContent.trim() : T('request_quote', 'Teklif İste'))).replace(/^ — /, '');
          pa.href = proj.getAttribute('href') || localeUrl('/pages/teklif');
          psub.appendChild(pa);
          dSeq += 1;
          psub.id = 'fav-dcat-sub-' + dSeq;
          bindToggle(ptgl, wrap, psub);
          wrap.appendChild(ptgl);
          wrap.appendChild(psub);
        } else {
          var a2 = el('a', 'fav-dcat-toggle', '<span></span>');
          a2.firstChild.textContent = title;
          a2.href = rootHref;
          wrap.appendChild(a2);
        }
        body.appendChild(wrap);
      });
    }

    var util = el('div', 'fav-drawer-contact');
    document.querySelectorAll('.fav-topbar .right a, .fav-topbar .left a').forEach(function (a) {
      var l = el('a', null, a.innerHTML);
      l.href = a.getAttribute('href') || '#';
      util.appendChild(l);
    });
    if (util.children.length) body.appendChild(util);

    drawer.appendChild(body);
    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);

    var lastFocus = null;
    function isOpen() { return drawer.classList.contains('open'); }
    function focusables() {
      return Array.prototype.filter.call(
        drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (n) { return n.offsetParent !== null || n === closeBtn; }
      );
    }
    function open() {
      if (isOpen()) return;
      lastFocus = document.activeElement;
      drawer.inert = false;
      drawer.removeAttribute('inert');
      drawer.classList.add('open');
      backdrop.classList.add('open');
      document.body.classList.add('fav-drawer-open');
      burger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      /* v28 a11y: odak cekmeceye tasinir */
      setTimeout(function () { try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); } }, 30);
    }
    function close() {
      if (!isOpen()) return;
      drawer.classList.remove('open');
      backdrop.classList.remove('open');
      document.body.classList.remove('fav-drawer-open');
      burger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
      drawer.setAttribute('inert', '');
      var back = (lastFocus && document.contains(lastFocus) && lastFocus !== document.body) ? lastFocus : burger;
      try { back.focus({ preventScroll: true }); } catch (e) {}
    }

    burger.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
          e.preventDefault(); first.focus();
        }
      }
    });
    drawer.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (a) {
        var href = a.getAttribute('href');
        if (href && href !== '#') close();
      }
    });
  }

  /* ---------------- Bottom navigation bar ---------------- */
  function buildBottomNav() {
    if (document.querySelector('.fav-bottom-nav')) return;

    function hrefOf(label, fallback) {
      var links = document.querySelectorAll('.fav-nav-icons a');
      for (var i = 0; i < links.length; i++) {
        var sp = links[i].querySelector('span');
        if (sp && sp.textContent.trim() === label) return links[i].getAttribute('href') || fallback;
      }
      return fallback;
    }
    var homeHref = localeUrl('/');
    var teklifHref = hrefOf(T('quote', 'Teklif'), localeUrl('/pages/teklif'));
    var hesapHref = hrefOf(T('account', 'Hesap'), hrefOf(T('my_account', 'Hesabım'), localeUrl('/account')));
    var cartLink = document.querySelector('.fav-nav-icons a[href*="cart"]');
    var cartHref = cartLink ? cartLink.getAttribute('href') : localeUrl('/cart');
    var cartBadge = document.querySelector('.fav-nav-icons .badge');
    var cartCount = cartBadge ? cartBadge.textContent.trim() : '';

    var path = location.pathname;
    function activeIf(cond) { return cond ? ' class="active"' : ''; }

    var nav = el('nav', 'fav-bottom-nav');
    nav.setAttribute('aria-label', T('nav_aria', 'Mobil navigasyon'));
    nav.innerHTML =
      '<a href="' + homeHref + '"' + activeIf(path === homeHref || path === homeHref + '/') + '>' + ICON_HOME + '<span class="bn-l" data-t="home"></span></a>' +
      '<button type="button" class="bn-cat">' + ICON_GRID + '<span class="bn-l" data-t="category"></span></button>' +
      '<a href="' + teklifHref + '"' + activeIf(path.indexOf('/teklif') > -1) + '>' + ICON_FILE + '<span class="bn-l" data-t="quote"></span></a>' +
      '<a href="' + hesapHref + '"' + activeIf(path.indexOf('account') > -1) + '>' + ICON_USER + '<span class="bn-l" data-t="account"></span></a>' +
      '<a href="' + cartHref + '"' + activeIf(path.indexOf('/cart') > -1) + '>' + ICON_CART +
        (cartCount ? '<span class="bn-badge">' + cartCount + '</span>' : '') + '<span class="bn-l" data-t="cart"></span></a>';

    var BN_LABELS = {
      home: T('home', 'Ana Sayfa'),
      category: T('category', 'Kategori'),
      quote: T('quote', 'Teklif'),
      account: T('account', 'Hesap'),
      cart: T('cart', 'Sepet')
    };
    nav.querySelectorAll('.bn-l').forEach(function (s) {
      s.textContent = BN_LABELS[s.getAttribute('data-t')];
    });

    document.body.appendChild(nav);
    document.body.classList.add('fav-has-bottom-nav');

    var catBtn = nav.querySelector('.bn-cat');
    if (catBtn) {
      catBtn.addEventListener('click', function () {
        var burger = document.getElementById('fav-hamburger');
        if (burger) burger.click();
      });
    }
  }

  /* ---------------- Sticky PDP CTA ---------------- */
  function buildStickyCta() {
    var card = document.querySelector('.fav-pdp .fav-pdp-price-card');
    if (!card || document.getElementById('fav-sticky-cta')) return;

    var addForm = document.getElementById('fav-add-form');
    var quoteModal = document.getElementById('fav-quote-modal');
    if (!addForm && !quoteModal) return;

    var bar = el('div', 'fav-sticky-cta');
    bar.id = 'fav-sticky-cta';

    var info = el('div', 'info', '<span class="lbl"></span><span class="val"></span>');
    var infoLbl = info.querySelector('.lbl');
    var infoVal = info.querySelector('.val');
    var nowEl = card.querySelector('.fav-pdp-price .now');
    if (addForm && nowEl) {
      infoLbl.textContent = T('price', 'Fiyat');
      infoVal.textContent = nowEl.textContent.trim();
    } else {
      infoLbl.textContent = T('project_product', 'Proje ürünü');
      infoVal.textContent = T('price_on_request', 'Fiyat için teklif');
    }
    bar.appendChild(info);

    var btn = el('a', 'fav-btn fav-btn-primary');
    btn.href = '#';
    if (addForm) {
      btn.textContent = T('add_to_cart', 'Sepete Ekle');
      var submit = addForm.querySelector('button[type="submit"]');
      if (submit && submit.disabled) {
        btn.setAttribute('aria-disabled', 'true');
        btn.style.opacity = '.5';
        btn.style.pointerEvents = 'none';
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (addForm.requestSubmit) addForm.requestSubmit();
        else addForm.submit();
      });
    } else {
      btn.textContent = T('request_quote', 'Teklif İste');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        quoteModal.classList.add('open');
      });
    }
    bar.appendChild(btn);

    document.body.appendChild(bar);
    document.body.classList.add('fav-has-sticky-cta');
    document.body.classList.remove('fav-has-bottom-nav');
  }

  ready(function () {
    try { buildDrawer(); } catch (e) {}
    try { buildBottomNav(); } catch (e) {}
    try { buildStickyCta(); } catch (e) {}
  });
})();

/* Hero slider — dokunmatik swipe (mevcut nokta navigasyonunu tetikler) */
(function () {
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    document.querySelectorAll('.fav-hero-slider').forEach(function(sl){
      var x0=null,y0=null;
      sl.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;y0=e.touches[0].clientY;},{passive:true});
      sl.addEventListener('touchend',function(e){
        if(x0===null)return;
        var dx=e.changedTouches[0].clientX-x0, dy=e.changedTouches[0].clientY-y0; x0=null;
        if(Math.abs(dx)<40 || Math.abs(dx)<Math.abs(dy)) return;
        var dots=sl.querySelectorAll('.fav-hero-dots .dot'); if(dots.length<2) return;
        var cur=0; dots.forEach(function(d,i){ if(d.classList.contains('active')) cur=i; });
        var t = dx<0 ? (cur+1)%dots.length : (cur-1+dots.length)%dots.length;
        dots[t].click();
      },{passive:true});
    });
  });
})();
